export default "__VITE_ASSET__8650de4c__"